<template>
  <div>
    <Card>
      <Table stripe  border :columns="columns" :data="caseList" :loading="showLoading"></Table>
      <Page class-name="page"
            :total="total"
            :page-size="pageSize"
            show-total
            ransfer="transfer"
            @on-change="pageNumChange"
            @on-page-size-change="onPageSizeChange"></Page>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'SlideTable',
  props: {
    caseId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      $vue: '',
      pageSize: 10,
      pageNum: 1,
      total: 10,
      transfer: true,
      showLoading: true,
      caseList: []
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t('slideTable.serialNumber'),
          width: 65,
          align: 'center',
          type: 'index'
        },
        {
          title: this.$t('slideTable.sample'),
          key: 'sample'
        },
        {
          title: this.$t('slideTable.slide'),
          key: 'slide'
        },
        {
          title: this.$t('slideTable.sampleType'),
          key: 'sample_types'
        },
        {
          title: this.$t('slideTable.analysisType'),
          key: 'fxff',
          width: 150
        },
        {
          title: this.$t('slideTable.analysisResult'),
          key: 'is_positive',
          width: 150,
          render: (h, row) => {
            let isPositive = row.row.is_positive
            if (isPositive === 0) {
              return h('span', this.$t('slideTable.feminine'))
            } else if (isPositive === 1) {
              return h('span', this.$t('slideTable.positive'))
            } else {
              return h('span', '/')
            }
          }
        },
        // {
        //   title: this.$t('slideTable.numberOfCells'),
        //   key: 'total_cell_count',
        //   width: 120,
        //   render: (h, row) => {
        //     let totalCellCount = row.row.total_cell_count
        //     if (totalCellCount === '' || totalCellCount === undefined) {
        //       return h('span', '/')
        //     } else {
        //       return h('span', totalCellCount)
        //     }
        //   }
        // },
        {
          title: this.$t('slideTable.status'),
          key: 'smzt',
          width: 120
        },
        {
          title: this.$t('slideTable.operation'),
          width: 200,
          align: 'center',
          render: (h, row) => {
            if (row.row.id === undefined) {
              return h('div', this.$t('slideTable.noSlides'))
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {},
                on: {
                  click: () => {
                    this.printSlideQrCode(row.row.id)
                  }
                }
              }, this.$t('slideTable.printBarcode')),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '8px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: this.$t('slideTable.deleteTipTitle'),
                      content: '<p>' + this.$t('slideTable.deleteTip') + '</p>',
                      onOk: () => {
                        this.removeSlide(row.row.id)
                      },
                      onCancel: () => {
                        // this.$Message.info('Clicked cancel')
                      }
                    })
                  }
                }
              }, this.$t('slideTable.delete'))
            ])
          }
        }
      ]
    }
  },
  beforeMount () {
    this.$vue = this
    this.getSlideList()
  },
  methods: {
    // 获取玻片列表
    async getSlideList () {
      this.showLoading = true
      let params = new URLSearchParams()
      params.append('pageSize', this.pageSize.toString())
      params.append('pageNum', this.pageNum.toString())
      params.append('caseId', this.caseId.toString())
      let suc = await this.$http.post(this.$vue.getData('GET_SAMPLE_SLIDE_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.caseList = data.list
        this.total = data.total
      }
      this.showLoading = false
    },
    // 页码改变时，回调方法
    pageNumChange (pageNum) {
      this.pageNum = pageNum
      // 重新获取列表
      this.getSlideList()
    },
    // 每页条数改变时回调方法
    onPageSizeChange (pageSize) {
      this.pageSize = pageSize
      // 重新获取列表
      this.getSlideList()
    },
    // 打印玻片二维码
    async printSlideQrCode (slideId) {
      let params = new URLSearchParams()
      params.append('slideId', slideId)
      params.append('userInfoId', localStorage.getItem('userId' + localStorage.getItem('userName')))
      let suc = await this.$http.post(this.$vue.getData('PRINT_SLIDE_QRCODE_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        let IsMoreSlides = data.length > 1 ? 'true' : 'false'
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let code = ''
          if (IsMoreSlides) {
            code = item.slide_code
          } else {
            code = item.pathology_id
          }
          let qrcode = '@' + item.slide_id
          try {
            window.HandleEvent('print', code, qrcode)
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
        }
      }
      console.log(suc)
    },
    // 删除玻片信息
    async removeSlide (slideId) {
      let params = new URLSearchParams()
      params.append('slideId', slideId)
      params.append('caseId', this.caseId)
      let suc = await this.$http.post(this.$vue.getData('DEL_SLIDE_BY_SLIDEID_URL'), params)
      let result
      if (suc.data.result === '1') {
        result = this.$t('slideTable.successfullyDeletedTip')
        this.getSlideList()
      } else {
        result = this.$t('slideTable.failedToDeleteTip')
      }
      this.$Notice.success({
        title: this.$t('slideTable.deletedTip'),
        desc: result
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .page
    margin-top 10px
    text-align right
  .over-width
    position relative
    white-space nowrap /* 溢出不换行 */
    overflow hidden
    text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// src/components/base/table/SlideTable.vue